"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const authStorage_1 = require("../../services/authStorage");
const store_1 = require("../../store/redux/store");
const account_1 = require("../../store/redux/account");
const OAuthCallback = () => {
    (0, react_1.useEffect)(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const expire = urlParams.get('expire');
        const refresh = urlParams.get('refresh');
        if (token && refresh && expire) {
            (0, authStorage_1.storeAuthItems)(token, refresh, parseInt(expire, 10));
            store_1.store.dispatch((0, account_1.authenticateAction)({
                accessToken: token,
                expDate: expire,
            }));
            window.location.href = window.location.origin + '/home';
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { children: "Redirecting..." }));
};
exports.default = OAuthCallback;
